import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import { areEqualIgnoreCase, imgUrl } from '@/shared/utils';
import { useConfigProvider } from '@/context/ConfigProvider';
import { Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { ActionType, ProList } from '@ant-design/pro-components';
import { useRouter } from 'next/router';
import _ from 'lodash';
import { getArticleListSearchData } from '@/lib/service';
import { HomeArticleModel } from '@/types/home';
import EmptyPage from '../Common/Empty';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

const SearchContent = () => {
  const { isMobile } = useConfigProvider();
  const actionRef = useRef<ActionType>();
  const router = useRouter();
  const { tag, keyword: value } = router.query;
  const [searchText, setSearchText] = useState<string | undefined>();
  const [inputText, setInputText] = useState(value);
  const [sortText, setSortText] = useState('clickNum');
  const [showEmpty, setShowEmpty] = useState<boolean>(false);
  const { t } = useTranslation();

  const tagRequest = tag != undefined;

  useEffect(() => {
    if (actionRef.current) {
      actionRef.current.reload();
    }
  }, [searchText, sortText]);

  useEffect(() => {
    if (tagRequest && actionRef.current) {
      actionRef.current.pageInfo.current = 1;
      setSearchText(`${tag}`);
    }
  }, [tag]);

  useEffect(() => {
    if (!tagRequest && actionRef.current) {
      actionRef.current.pageInfo.current = 1;
      setSearchText(`${value}`);
    }
  }, [value]);

  const onChange = (value: string) => {
    if (value == sortText) {
      return;
    }
    setSortText(value);
  };

  // 搜索关键词
  const onChangeKeyword = (e: any) => {
    if (e.key !== 'Enter') return;
    router.push(`/search?keyword=${e.target.value}`);
  };

  return (
    <div className={classNames(styles.popularProductsContainer, '')} style={{ minHeight: '100vh' }}>
      <div className={styles.homeContent}>
        <div className={styles.titleContainer}>
          <h3 className={styles.title}>
            {tagRequest ? (
              tag
            ) : (
              <Space>
                <SearchOutlined /> {`${t('search')}:`}
                <input
                  value={inputText}
                  onChange={(e) => setInputText(e.target.value)}
                  type="text"
                  className={styles.inputKeword}
                  onKeyDown={onChangeKeyword}
                />
              </Space>
            )}
          </h3>
        </div>

        {!tagRequest && (
          <div className={styles.searchContainer}>
            <Select
              style={{ minWidth: 182 }}
              defaultValue={sortText}
              optionFilterProp="children"
              onChange={onChange}
              options={[
                {
                  value: 'clickNum',
                  label: `${t('popularHighToLow')}`,
                },
                {
                  value: 'insertTime',
                  label: `${t('dateNewestToOldest')}`,
                },
              ]}
            />
          </div>
        )}

        <div className={styles.rowListContainer}>
          <ProList<any>
            className={styles.proListContainer}
            actionRef={actionRef}
            ghost={true}
            pagination={{
              defaultPageSize: 12,
              showSizeChanger: false,
              align: 'center',
              showTotal: null,
            }}
            showActions="hover"
            onItem={(record: HomeArticleModel) => {
              return {
                onClick: () => {
                  if (record?.article_id != undefined) {
                    // router.push(
                    //   `/instagram-tracking-blog/${record?.article_id}/${getPathTitle(
                    //     record?.title,
                    //   )}`,
                    // );
                    router.push(`/instagram-tracking-blog/${record?.title_id}`);
                  }
                },
              };
            }}
            itemCardProps={{
              bodyStyle: {
                margin: 0,
                padding: 0,
              },
            }}
            metas={{
              title: {
                render: (_, reacd: HomeArticleModel) => {
                  return (
                    <div className={styles.contentItem}>
                      {reacd?.cover_image ? (
                        <div className="w-[263px] shrink-0 h-[148px]">
                          <Image
                            className={styles.imgItem}
                            src={imgUrl(reacd?.cover_image, 'mid')}
                            alt={reacd?.title}
                            loading="lazy"
                            width={263}
                            height={148}
                            layout="responsive"
                            style={{ aspectRatio: isMobile ? '1' : '16/9' }}
                          />
                        </div>
                      ) : null}
                      <div className={styles.titleContainer}>
                        <Link
                          href={`/instagram-tracking-blog/${reacd?.title_id}`}
                          // href={`/instagram-tracking-blog/${reacd?.article_id}/${getPathTitle(
                          //   reacd?.title,
                          // )}`}
                        >
                          <div className={styles.title}>{reacd?.title}</div>
                        </Link>

                        {reacd?.labels?.length > 0 && (
                          <div className={styles.tagContiner}>
                            <span className={styles.tagTitle}>{t('tags')}:</span>
                            {(reacd?.labels ?? []).map((item: string, index: number) => {
                              var color = `var(--app-link-color)`;
                              if (tagRequest && areEqualIgnoreCase(`${tag}`, `${item}`)) {
                                color = '#725CFF';
                              }

                              const itemStr = index == reacd?.labels.length - 1 ? item : `${item},`;
                              return (
                                <Link
                                  className={styles.tagContent}
                                  style={{ color: color }}
                                  key={index}
                                  href={`/search?tag=${item}`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  {itemStr}{' '}
                                </Link>
                              );
                            })}
                          </div>
                        )}
                        <div className={styles.desc}>{reacd?.description}</div>
                        <div className={styles.time}>{reacd?.create_time}</div>
                      </div>
                    </div>
                  );
                },
              },
            }}
            request={async (params: any) => {
              const tempParams = tagRequest
                ? {
                    label: searchText,
                    order_column: sortText,
                    page_no: params.current,
                    page_size: params.pageSize,
                  }
                : {
                    title: searchText,
                    order_column: sortText,
                    page_no: params.current,
                    page_size: params.pageSize,
                  };

              const res = await getArticleListSearchData(tempParams, tagRequest, router.locale);
              setShowEmpty(res == undefined || (res?.data?.length ?? 0) == 0);

              var idList: number[] = [];

              const tempList = (res?.data ?? []).filter((item) => {
                if (!idList.includes(item.article_id)) {
                  idList.push(item.article_id);
                  return true;
                }
                return false;
              });
              return {
                ...res,
                data: tempList,
              };
            }}
          />

          <div className={styles.empty} style={{ display: showEmpty ? 'block' : 'none' }}>
            <EmptyPage />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchContent;
